module.exports = __webpack_public_path__ + "static/media/CANSOFCOM.b5b60a4d.png";